import condominioForYou from '../../img/sponsor-img/c4u-logo-registrato.svg'
import kiatsongrit from '../../img/sponsor-img/kiatsongrit.webp'
import sapImpianti from '../../img/sponsor-img/sapImpianti.webp'
import antonioAmmaturo from '../../img/sponsor-img/antonioammaturo.webp'

/* `category` è la riga di descrizione sotto ogni nome, presa dal marchio
   di ciascun partner. Modificabile liberamente. */
export const SponsorData = [
    {
        id: 0,
        name: 'Condominio For You',
        category: 'Amministrazione condominiale',
        img: condominioForYou,
        link: "https://condominioforyou.com"
    },
    {
        id: 1,
        name: 'Kiatsongrit Gym',
        category: 'Shinkoh Muay Thai — Bangkok',
        img: kiatsongrit,
        link: "https://www.instagram.com/kiatsongrit_gym/"
    },
    {
        id: 2,
        name: 'SAP Impianti',
        category: 'Impianti tecnologici e antincendio',
        img: sapImpianti,
        link: "https://www.sapiimpianti.com/"
    },
    {
        id: 3,
        name: "Istituto Sant'Antonio",
        category: 'Centro scolastico paritario',
        img: antonioAmmaturo,
        link: "https://www.istituto-santantonio.it/"
    }
]
